import { Home } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useNavigationMenu } from '@/hooks/useNavigationMenu';
import { resolvePageNavigation } from '@/lib/menuNavigation';

export default function NexusBreadcrumb() {
  const menu = useNavigationMenu();
  const location = useLocation();
  const navigation = resolvePageNavigation(menu, location.pathname);
  const homeHref = menu.find((item) => item.id === 'dashboard')?.href ?? menu.find((item) => item.href)?.href ?? '/layout';
  const crumbs = [{ label: 'Industrialização', href: homeHref }, ...(navigation?.crumbs ?? [])];
  return (
    <nav className="nx-breadcrumb" aria-label="Navegação estrutural">
      <Home className="nx-breadcrumb-home" size={15} aria-hidden />
      <ol className="nx-breadcrumb-list">
        {crumbs.map((crumb, index) => {
          const last = index === crumbs.length - 1;
          return <li key={`${index}-${crumb.label}`} className="nx-breadcrumb-item">
            {index > 0 && <span className="nx-breadcrumb-sep" aria-hidden>&gt;</span>}
            {!last && crumb.href ? <Link to={crumb.href} className="nx-breadcrumb-link">{crumb.label}</Link>
              : <span className={last ? 'nx-breadcrumb-current' : 'nx-breadcrumb-text'} aria-current={last ? 'page' : undefined}>{crumb.label}</span>}
          </li>;
        })}
      </ol>
    </nav>
  );
}
